module.exports = __webpack_public_path__ + "img/about-left-shape.2b77e225.png";